const vietnamese = {
    pagination: {
        labelDisplayedRows: '{from}-{to} trong tổng số {count} mục',
        labelRowsSelect: 'mục',
        labelRowsPerPage: 'mục/trang',
        firstAriaLabel: 'Trang đầu',
        firstTooltip: 'Trang đầu',
        previousAriaLabel: 'Trang trước',
        previousTooltip: 'Trang trước',
        nextAriaLabel: 'Trang tiếp',
        nextTooltip: 'Trang tiếp',
        lastAriaLabel: 'Trang cuối',
        lastTooltip: 'Trang cuối'

    },
    toolbar: {
        nRowsSelected: '{0} mục được chọn',
        searchPlaceholder: 'Tìm',
        searchTooltip: 'Tìm kiếm'
    },
    body: {
        emptyDataSourceMessage: 'Không có kết quả',
        filterRow: {
            filterTooltip: 'Lọc'
        }
    }
};

export default vietnamese;